import React from 'react';

import { UpwardAdvancedLoader } from 'ui';

const Loader = () => (
   <>
      <div style={{ height: '80vh' }}>
         <UpwardAdvancedLoader size='120' />
      </div>
   </>
);

export default Loader;
